module.exports = __webpack_public_path__ + "packs/media/images/chat_back_icon-64da7563eb8710847ee18634a3d52097.png";